<template>
  <div class="my-12 md:my-20 container relative max-w-screen-md">
    <div v-if="index" class="lg:absolute lg:top-0 lg:-left-20 mb-4 fluid-3xl leading-tightest font-semibold">
      {{ padNumber(index) }}
    </div>
    <CraftAsset
      v-if="image[0]"
      :alt="alt"
      :asset="image[0]"
      :ratio="3 / 2"
      :width="700"
      crop="fill"
      :autoplay="autoplay"
      sizes="700px"
    />
    <div class="text-copy fluid-lg font-light leading-normal" v-html="body"></div>
  </div>
</template>
<script>
import CraftAsset from '@/components/common/CraftAsset';
import { padNumber } from '@/utils/common';

export default defineNuxtComponent({
  components: {
    CraftAsset,
  },

  props: {
    index: {
      type: Number,
      default: null,
    },
    alt: {
      type: String,
      default: '',
    },
    image: {
      type: Array,
      default: () => [],
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    body: {
      type: String,
      default: '',
    },
    crop: {
      type: String,
      default: null,
    },
  },

  methods: {
    padNumber,
  },
});
</script>
